/** @file The draw order a panel shows: setup order, or the stepped draw-order key in force at the playhead. */
import type { Doc, Id } from '@pose2d/format/types';
import type { EditTarget } from '../rigKit/rigView';

/** The order shown (back-to-front) and whether a draw-order key sits exactly on the playhead frame. */
export interface ShownOrder {
  order: readonly Id[];
  keyHere: boolean;
}

/** Draw-order keys are stepped: the last key at or before the frame wins; none, or a null key, means the setup order. */
export function shownOrder(doc: Doc, target: EditTarget): ShownOrder {
  if (target.kind === 'setup') return { order: doc.drawOrder, keyHere: false };
  let last: { f: number; order: Id[] | null } | undefined;
  for (const key of doc.animations[target.animation]?.drawOrder ?? []) if (key.f <= target.frame) last = key;
  return { order: last?.order ?? doc.drawOrder, keyHere: last?.f === target.frame };
}
